<div class="content-card">
  <h2 class="content-card__header">{{ 'WF-PersonalData' | translate }}</h2>

  <form [formGroup]="stepOneForm">
    <div class="row mb-2">
      <div class="col-6">
        <mat-checkbox class="bold" formControlName="noAccount">
          {{ 'WorkerWithoutAccount' | translate }}
        </mat-checkbox>
      </div>
      <div [visibleWithPermissions]="['DisableNameValidation']" class="col-6">
        <mat-checkbox formControlName="disabledNameValidation">
          {{ 'DisableNameValidation' | translate }}
        </mat-checkbox>
      </div>
    </div>

    <div class="row">
      <div class="col-12 col-lg-6">
        <mat-form-field appearance="outline">
          <mat-label>{{ 'FirstName' | translate }}</mat-label>
          <input matInput placeholder="{{ 'FirstName' | translate }}" formControlName="firstName" autocomplete="given-name" required />
          @if (firstName.invalid && firstName.touched) {
            <mat-error>
              {{ 'InvalidField' | translate }}
            </mat-error>
          }
        </mat-form-field>
      </div>

      <div class="col-12 col-lg-6">
        <mat-form-field appearance="outline">
          <mat-label>{{ 'SecondName' | translate }}</mat-label>
          <input matInput placeholder="{{ 'SecondName' | translate }}" autocomplete="additional-name" formControlName="secondName" />
          @if (secondName.invalid && secondName.touched) {
            <mat-error>
              {{ 'InvalidField' | translate }}
            </mat-error>
          }
        </mat-form-field>
      </div>
    </div>

    <div class="row">
      <div class="col-12 col-lg-6">
        <mat-form-field appearance="outline">
          <mat-label>{{ 'LastName' | translate }}</mat-label>
          <input matInput placeholder="{{ 'LastName' | translate }}" formControlName="lastName" autocomplete="family-name" required />
          @if (lastName.invalid && lastName.touched) {
            <mat-error>
              {{ 'InvalidField' | translate }}
            </mat-error>
          }
        </mat-form-field>
      </div>

      <div class="col-12 col-lg-6">
        <mat-form-field appearance="outline">
          <mat-label>{{ 'MaidenName' | translate }}</mat-label>
          <input matInput placeholder="{{ 'MaidenName' | translate }}" formControlName="maidenName" autocomplete="family-name" />
          @if (maidenName.invalid && maidenName.touched) {
            <mat-error>
              {{ 'InvalidField' | translate }}
            </mat-error>
          }
        </mat-form-field>
      </div>
    </div>

    <div class="row">
      <div class="col-12 col-lg-3">
        <mat-form-field appearance="outline">
          <mat-label>{{ 'PhoneCode' | translate }}</mat-label>
          <mat-select formControlName="phoneCodeId" required>
            @for (phoneCode of listOfPhoneCodes$ | async; track phoneCode) {
              <mat-option #matOption [value]="phoneCode.Id">{{ phoneCode.Prefix }}</mat-option>
            }
          </mat-select>
          @if (phoneCodeId.invalid && phoneCodeId.touched) {
            <mat-error>
              {{ 'InvalidField' | translate }}
            </mat-error>
          }
        </mat-form-field>
      </div>

      <div class="col-12 col-lg-3">
        <mat-form-field appearance="outline">
          <mat-label>{{ 'PhoneNumber' | translate }}</mat-label>
          <input matInput #phoneNumberInput placeholder="{{ 'PhoneNumber' | translate }}" formControlName="phoneNumber" appNumbersOnly required />
          @if (phoneNumber.invalid && phoneNumber.touched) {
            <mat-error>
              {{ 'InvalidField' | translate }}
            </mat-error>
          }
        </mat-form-field>
      </div>

      <div class="col-12 col-lg-6">
        <mat-form-field appearance="outline">
          <mat-label>{{ 'Email' | translate }}</mat-label>
          <input matInput type="email" placeholder="{{ 'Email' | translate }}" formControlName="email" required />
          @if (email.invalid && email.touched) {
            <mat-error>
              {{ 'InvalidField' | translate }}
            </mat-error>
          }
        </mat-form-field>
      </div>
    </div>

    <div class="row row--checkbox">
      <div class="col-12">
        <mat-checkbox formControlName="isForeigner">
          {{ 'Foreigner' | translate }}
        </mat-checkbox>
      </div>
    </div>

    <div class="row">
      <div class="col-12 col-lg-3">
        <mat-form-field appearance="outline">
          <mat-label>{{ 'Gender' | translate }}</mat-label>
          <mat-select formControlName="genderId">
            <mat-option #matOption [value]="null"></mat-option>
            @for (gender of listOfGenders$ | async; track gender) {
              <mat-option #matOption [value]="gender.Id">{{ gender.Name }}</mat-option>
            }
          </mat-select>
          @if (genderId.invalid && genderId.touched) {
            <mat-error>
              {{ 'InvalidField' | translate }}
            </mat-error>
          }
        </mat-form-field>
      </div>

      <div class="col-12 col-lg-3">
        <mat-form-field appearance="outline">
          <mat-label>{{ 'Citizenship' | translate }}</mat-label>
          <input
            matInput
            type="text"
            formControlName="citizenship"
            placeholder="{{ 'Citizenship' | translate }}"
            [matAutocomplete]="autocompleteCitizenship"
            required
            />
            <mat-autocomplete #autocompleteCitizenship="matAutocomplete" [displayWith]="displayValue">
              @for (citizenship of listOfCitizentship$ | async; track citizenship) {
                <mat-option
                  [value]="citizenship"
                  (onSelectionChange)="onSelectionCitizenshipChange(citizenship)"
                  >
                  {{ citizenship.Name }}
                </mat-option>
              }
            </mat-autocomplete>
            @if (citizenship.invalid && citizenship.touched) {
              <mat-error>
                {{ 'InvalidField' | translate }}
              </mat-error>
            }
          </mat-form-field>
        </div>
      </div>

      <div class="row">
        <div class="col-12 col-lg-3">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'Pesel' | translate }}</mat-label>
            <input
              matInput
              appNumbersOnly
              type="text"
              placeholder="{{ 'Pesel' | translate }}"
              formControlName="pesel"
              autocomplete="pesel"
              [maxLength]="11"
              />
              @if (pesel.invalid && pesel.touched) {
                <mat-error>
                  {{ 'InvalidField' | translate }}
                </mat-error>
              }
            </mat-form-field>
          </div>

          <div class="col-12 col-lg-3">
            <mat-form-field appearance="outline">
              <mat-label>{{ 'DateOfBirth' | translate }}</mat-label>
              <input matInput [matDatepicker]="birthDatePicker" formControlName="dateOfBirth" [matDatepickerFilter]="dateFilter" autocomplete="date" />
              <mat-datepicker-toggle [for]="birthDatePicker" matSuffix></mat-datepicker-toggle>
              <mat-datepicker #birthDatePicker startView="multi-year" [startAt]="startDate"></mat-datepicker>
              @if (dateOfBirth.invalid && dateOfBirth.touched) {
                <mat-error>
                  {{ 'InvalidField' | translate }}
                </mat-error>
              }
            </mat-form-field>
          </div>

          @if (isForeigner) {
            <div class="col-12 col-lg-3">
              <mat-form-field appearance="outline">
                <mat-label>{{ 'Nip' | translate }}</mat-label>
                <input
                  matInput
                  appNumbersOnly
                  type="text"
                  placeholder="{{ 'Nip' | translate }}"
                  formControlName="nip"
                  autocomplete="nip"
                  [minLength]="10"
                  [maxLength]="10"
                  />
                  @if (nip.invalid && nip.touched) {
                    <mat-error>
                      {{ 'InvalidField' | translate }}
                    </mat-error>
                  }
                </mat-form-field>
              </div>
            }
          </div>

          <div class="row">
            @if (isForeigner) {
              <div class="col-12 col-lg-3">
                <mat-form-field appearance="outline">
                  <mat-label>{{ 'IdentityDocumentType' | translate }}</mat-label>
                  <mat-select formControlName="identityDocumentTypeId">
                    @for (identityDocument of identityDocumentTypes$ | async; track identityDocument) {
                      <mat-option #matOption [value]="identityDocument.Id">{{
                        identityDocument.Name
                      }}</mat-option>
                    }
                  </mat-select>
                  @if (identityDocumentTypeId.invalid && identityDocumentTypeId.touched) {
                    <mat-error>
                      {{ 'InvalidField' | translate }}
                    </mat-error>
                  }
                </mat-form-field>
              </div>
            }

            @if (isForeigner) {
              <div class="col-12 col-lg-3">
                <div class="row">
                  @if (!!selectedIdentityDocumentType?.HasSerialNumber && selectedIdentityDocumentType?.Id === identityDocumentTypeEnum.IdentityCard) {
                    <div class="col-6">
                      <mat-form-field appearance="outline">
                        <mat-label>{{ 'DocumentSerial' | translate }}</mat-label>
                        <input
                          matInput
                          type="text"
                          placeholder="{{ 'DocumentSerial' | translate }}"
                          formControlName="documentSerial"
                          autocomplete="documentSerial"
                          [maxlength]="serialLength"
                          toUppercaseInput
                          />
                          @if (documentSerial.invalid && documentSerial.touched) {
                            <mat-error>
                              {{ 'InvalidField' | translate }}
                            </mat-error>
                          }
                        </mat-form-field>
                      </div>
                      @if (isForeigner) {
                        <div class="col-6">
                          <mat-form-field appearance="outline">
                            <mat-label>{{ 'DocumentNumber' | translate }}</mat-label>
                            <input
                              matInput
                              type="text"
                              placeholder="{{ 'DocumentNumber' | translate }}"
                              formControlName="documentNumber"
                              autocomplete="documentNumber"
                              [maxlength]="numberLength"
                              />
                              @if (documentNumber.invalid && documentNumber.touched) {
                                <mat-error>
                                  {{ 'InvalidField' | translate }}
                                </mat-error>
                              }
                            </mat-form-field>
                          </div>
                        }
                      }
                      @if (!!selectedIdentityDocumentType?.HasSerialNumber && selectedIdentityDocumentType?.Id !== identityDocumentTypeEnum.IdentityCard) {
                        <div class="col-12">
                          <mat-form-field appearance="outline">
                            <mat-label>{{ identityDocumentTypeEnum[selectedIdentityDocumentType.Id] + 'Number' | translate }}</mat-label>
                            <input matInput type="text" formControlName="documentNumber" autocomplete="documentNumber" [maxlength]="numberLength" />
                            @if (documentNumber.invalid && documentNumber.touched) {
                              <mat-error>
                                {{ 'InvalidField' | translate }}
                              </mat-error>
                            }
                          </mat-form-field>
                        </div>
                      }
                    </div>
                  </div>
                }
                @if (isForeigner) {
                  <div class="col-12 col-lg-3">
                    @if (identityDocumentTypeId.value) {
                      <mat-form-field appearance="outline">
                        <mat-label>{{ 'DocumentExpirationDate' | translate }}</mat-label>
                        <input
                          matInput
                          [matDatepicker]="documentExpirationDateDatePicker"
                          formControlName="documentExpirationDate"
                          [matDatepickerFilter]="expirationDateFilter"
                          autocomplete="date"
                          />
                          <mat-datepicker-toggle [for]="documentExpirationDateDatePicker" matSuffix></mat-datepicker-toggle>
                          <mat-datepicker #documentExpirationDateDatePicker></mat-datepicker>
                          @if (documentExpirationDate.invalid && documentExpirationDate.touched) {
                            <mat-error>
                              {{ 'InvalidField' | translate }}
                            </mat-error>
                          }
                          @if (documentExpirationDate.errors?.dateInvalid) {
                            <mat-error>
                              {{ 'DocumentExpirationDateInvalid' | translate }}
                            </mat-error>
                          }
                        </mat-form-field>
                      }
                    </div>
                  }
                </div>
                <div class="header-wrapper"></div>
                @if (this.settings?.IsDriver) {
                  <div class="row">
                    <div class="col-3">
                      <mat-form-field appearance="outline">
                        <mat-label>{{ 'DriverLicenceCountry' | translate }}</mat-label>
                        <mat-select formControlName="driverLicenceCountry">
                          @for (country of listOfCountries$ | async; track country) {
                            <mat-option [value]="country.Id"> {{ country.Name }} </mat-option>
                          }
                        </mat-select>
                      </mat-form-field>
                    </div>
                    <div class="col-3">
                      <mat-form-field appearance="outline">
                        <mat-label>{{ 'DriverLicenceNumber' | translate }}</mat-label>
                        <input
                          matInput
                          type="text"
                          placeholder="{{ 'DriverLicenceNumber' | translate }}"
                          formControlName="driverLicenceNumber"
                          autocomplete="documentNumber"
                          [maxlength]="driverLicenceLength"
                          toUppercaseInput
                          />
                          @if (documentNumber.invalid && documentNumber.touched) {
                            <mat-error>
                              {{ 'InvalidField' | translate }}
                            </mat-error>
                          }
                        </mat-form-field>
                      </div>
                      <div class="col-3">
                        <mat-form-field appearance="outline">
                          <mat-label>{{ 'DriverLicenceExpirationDate' | translate }}</mat-label>
                          <input
                            matInput
                            [matDatepicker]="driverLicenceExpirationDateDatePicker"
                            formControlName="driverLicenceExpirationDate"
                            [matDatepickerFilter]="expirationDateFilter"
                            autocomplete="date"
                            />
                            <mat-datepicker-toggle [for]="driverLicenceExpirationDateDatePicker" matSuffix></mat-datepicker-toggle>
                            <mat-datepicker #driverLicenceExpirationDateDatePicker></mat-datepicker>
                            @if (driverLicenceExpirationDate.invalid && driverLicenceExpirationDate.touched) {
                              <mat-error>
                                {{ 'InvalidField' | translate }}
                              </mat-error>
                            }
                            @if (driverLicenceExpirationDate.errors?.dateInvalid) {
                              <mat-error>
                                {{ 'DriverLicenceExpirationDateInvalid' | translate }}
                              </mat-error>
                            }
                          </mat-form-field>
                        </div>
                        <div class="col-3">
                          <mat-checkbox formControlName="permanentLicence">{{ 'PermanentLicence' | translate }}</mat-checkbox>
                        </div>
                      </div>
                    }
                    @if (this.driverLicenceCountry.value !== Country.Poland) {
                      <div fxLayout="row">
                        <alert message="ForeignDriverLicenceInfo" alertType="info" class="driver-licence-info"></alert>
                      </div>
                    }

                    <div fxLayout="row" fxLayoutAlign="end center">
                      <button mat-raised-button color="primary" (click)="submitPersonalData(false)">{{ 'Next' | translate }}</button>
                    </div>
                  </form>
                </div>
